export type EmailAddress = string & { readonly __brand: 'EmailAddress' };

const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function emailAddress(value: string): EmailAddress {
  const trimmed = value.trim().toLowerCase();
  if (!EMAIL_RX.test(trimmed)) {
    throw new Error(`Invalid EmailAddress: ${value}`);
  }
  return trimmed as EmailAddress;
}

export function isEmailAddress(value: string): boolean {
  return EMAIL_RX.test(value.trim());
}
